import "./CookiePolicy.module.css";
import Header from "@/reusable_sections/Header";
import CookiePolicy from "./sections/CookiePolicy";
import Footer from "@/reusable_sections/Footer";
export default function CookiePolicyPage() {
  return <div>
      <Header />
      <CookiePolicy />
      <Footer />
    </div>;
}